import { LOCALE_CONFIG } from '../../configs'

export const compareStringsIntl = new Intl.Collator(LOCALE_CONFIG.default).compare
